import '../../styles/app.css'
import '../../styles/messages.css'

const CustomMessageBot = (props) => {

    return (
        <div className="message-container">
            <div
                className="bot-message"
                dangerouslySetInnerHTML={{ __html: props.payload.text }}>
            </div>
        </div>
    )
}

export default CustomMessageBot